import React from 'react'

const IconFilterChips = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      className='filterIcon'
    >
      <path
        d='M8.60971 15.1668V9.96968L3.57617 4.81738H14.7299L9.69617 9.96968V15.1668H8.60971ZM14.9191 14.0705L14.4335 13.6011L15.9205 12.1572H12.3372V11.4905H15.9205L14.4335 10.0466L14.9191 9.56093L17.1674 11.8238L14.9191 14.0705ZM9.16096 9.49697L13.1128 5.48405H5.18826L9.16096 9.49697Z'
        fill='#686867'
      />
    </svg>
  )
}

export default IconFilterChips
